import _reduxForm from "redux-form/es/reduxForm";
import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import Block from 'swag-client-common/components/ui/block';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import { RectangleInput } from 'swag-client-common/components/inputs/rectangle-input';
import { DropdownInput } from 'swag-client-common/components/inputs/dropdown-input';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import { phoneNumber } from 'swag-client-common/utils/redux-form-validators';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import classes from './profile-settings.scss';
const ProfileSettingsForm = ({
  email,
  departmentValues,
  showCompanyField = true,
  isLoading,
  isError,
  isSuccess,
  errorMessage,
  handleSubmit,
  onSubmit
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Block, {
    className: classes.formContainer
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(RectangleInput, {
    name: "email",
    className: classes.formInput,
    formType: "text",
    input: {
      value: email,
      disabled: true
    },
    dataInput: "Email",
    label: "Email"
  }), /*#__PURE__*/React.createElement(_Field, {
    name: "firstName",
    component: RectangleInput,
    className: classes.formInput,
    formType: "text",
    label: "First name"
  }), /*#__PURE__*/React.createElement(_Field, {
    name: "lastName",
    component: RectangleInput,
    className: classes.formInput,
    formType: "text",
    label: "Last name"
  }), /*#__PURE__*/React.createElement(_Field, {
    name: "phoneNumber",
    component: RectangleInput,
    className: classes.formInput,
    validate: [phoneNumber],
    formType: "text",
    label: "Phone number"
  }), showCompanyField && /*#__PURE__*/React.createElement(_Field, {
    name: "company",
    component: RectangleInput,
    className: classes.formInput,
    formType: "text",
    label: "Company"
  }), departmentValues && /*#__PURE__*/React.createElement(_Field, {
    name: "department",
    component: DropdownInput,
    className: classes.formInput,
    values: departmentValues,
    label: "Department"
  }), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    loading: isLoading,
    className: classnames(utilClasses.marginV25, classes.formButton),
    formType: "submit",
    textTransform: ButtonTextTransform.none
  }, "Update"), isError && /*#__PURE__*/React.createElement("div", {
    className: utilClasses.error
  }, errorMessage), isSuccess && /*#__PURE__*/React.createElement("div", {
    className: utilClasses.success
  }, "Your profile was successfully updated"))), /*#__PURE__*/React.createElement(LoadingOverlay, {
    isShown: Boolean(isLoading)
  }));
};
export const ProfileSettingsComponent = _reduxForm({
  form: 'profileSettings',
  enableReinitialize: true
})(ProfileSettingsForm);